
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/overview/[type]",
      function () {
        return require("private-next-pages/overview/[type].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/overview/[type]"])
      });
    }
  